import { TFunction } from 'i18next';
import { FormVersionConflictCode } from 'models/tasks/formVersion';
import AppError from 'utils/appError';

//The 409 code the API attaches to a form versioning refusal, when the error carries one.
export const getFormVersionConflictCode = (err: unknown): string | undefined => {
  return err instanceof AppError && err.code === '409' ? (err.data?.code as string | undefined) : undefined;
};

//The user's text for a form versioning refusal: one sentence per code, in the user's language. The
//server's message is English and names the rule, not what the user can do; this does. Undefined for
//a code this list does not know, so the caller falls back to its generic handling.
export const getFormVersionConflictText = (code: string | undefined, t: TFunction<string[]>): string | undefined => {
  switch (code) {
    case FormVersionConflictCode.UpgradeTaskClosed:
      return t('forms:Versioning.Upgrade.Errors.Closed');
    case FormVersionConflictCode.UpgradeTaskAnswered:
      return t('forms:Versioning.Upgrade.Errors.Answered');
    case FormVersionConflictCode.UpgradeNotConsumer:
      return t('forms:Versioning.Upgrade.Errors.NotConsumer');
    case FormVersionConflictCode.FamilyArchived:
      return t('forms:Versioning.Conflicts.FamilyArchived');
    case FormVersionConflictCode.FamilyNotMigrated:
      return t('forms:Versioning.Conflicts.FamilyNotMigrated');
    case FormVersionConflictCode.TaskReplaceRefused:
      return t('forms:Versioning.Conflicts.TaskReplaceRefused');
    case FormVersionConflictCode.FamilyPinnedByConcreteWork:
      return t('forms:Versioning.Conflicts.FamilyPinnedByConcreteWork');
    case FormVersionConflictCode.TaskFormVersionMoved:
      return t('forms:Versioning.Conflicts.TaskFormVersionMoved');
    default:
      return undefined;
  }
};
